/**
 * Which organisation is signed in.
 *
 * Three places built their own answer and all three got it wrong the same way:
 *
 *   const orgId = localStorage.getItem('organizationId') || '1';
 *
 * Nothing in the panel ever writes `organizationId` — three files read it, none
 * sets it — so the fallback was not a fallback, it was the answer. Every clinic
 * was shown a webhook URL ending /1/, and webhook_logs has six "Integration not
 * found" failures against org 1 from someone who tried to use one.
 *
 * The real value has been in the stored user object since login, which is what
 * AgentPlayground already reads. This is that read, in one place.
 *
 * Returns null rather than guessing. A webhook URL built on a guessed
 * organisation is worse than no URL: it fails quietly, in a different clinic's
 * name, and looks right while doing it.
 */
export function getCurrentOrgId() {
    try {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        const id = user.organization_id || user.organizationId || user.org_id;
        return id != null && id !== '' ? String(id) : null;
    } catch (e) {
        // Storage blocked, or a half-written value. Either way we do not know.
        return null;
    }
}

export default getCurrentOrgId;
